

export default (function (d) {
  return d;
});
//# sourceMappingURL=identity.js.map